import { getApiClient } from 'adapter/out/client/apiClient';
import ReadStoredAnalysisCriteria from 'use-case/storedAnalysis/read/readStoredAnalysisCriteria';
import StoredAnalysis from 'domain/entity/storedAnalysis';

const getReadStoredAnalysisApiClient = getApiClient(
    (criteria: ReadStoredAnalysisCriteria) => `dashboards/stored-analyses/${criteria.id}`,
    StoredAnalysis
);

export default getReadStoredAnalysisApiClient;
